import React, { useState, useEffect } from 'react';
import { motion,AnimatePresence } from "framer-motion"
import axios from 'axios';
import Logo from './logo';
import Delivered from './icon/delivered';
import Warehouse from './icon/warehouse';
import Delivery from './icon/delivery';
import Collect from './icon/collect';
import Assign from './icon/assign';
import Api from './icon/api';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import './style.scss';

const App = () => {

  const { tracking } = useParams();

  useEffect(() => {
   // console.log('IN')    
    if(tracking){ //get param
      setloading(true)
      axios.post(`https://integration-logistic.cardinal.dev/api/tracking/status`, { tracking }, {
        headers: {
          'User-Agent': 'Cardinal (http://tracking.cardinal.dev)'
        }
      })
      .then(res => {
        setloading(false);
        
        if(res.status === 200){
          //setformData({...formData,_id:res.data._id});
          setstatusData(res.data)
          setloading(false);
          setComplete(true)
    
        }else{
          //show error ID not exist
          setstatusData([])
          setComplete(true)
          setloading(false);
        }
      });
    }else{
      setTimeout(()=>setisVisible(true), 500);
    }
  }, [])
  
  const [formData, setformData] = useState({
    tracking:'',
  });

  const [error, setError] = useState(false);
  const [statusData, setstatusData] = useState([]);

  const spinTransition = {
    loop: Infinity,
    ease: "linear",
    duration: 1
  };
  const circleStyle = {
    display: "block",
    width: "1.5rem",
    height: "1.5rem",
    border: "0.3rem solid #e9e9e9",
    borderTop: "0.3rem solid #fe8713",
    borderRadius: "50%",
    position: "absolute",
    boxSizing: "border-box",
    top: 0,
    left: 0
  };

  const [isVisible, setisVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [Complete, setComplete] = useState(false);

   const _handleTracking = (e) =>{
   
  //  var numbers = /^[0-9]+$/;
    setformData({...formData,tracking:e.target.value})
     // if(e.target.value.match(numbers)){  }
  }


  const handleSubmit = event => {
    event.preventDefault();
    setError(false);
    if(formData.tracking){

      setloading(true)
      axios.post(`https://integration-logistic.cardinal.dev/api/tracking/status`, { ...formData }, {
        headers: {
          'User-Agent': 'Cardinal (https://tracking.cardinal.dev)'
        }
      })
      .then(res => {
        setloading(false);
        
        if(res.status === 200){
          //setformData({...formData,_id:res.data._id});
          setstatusData(res.data)
          setloading(false);
          setComplete(true)
    
        }else{
          //show error ID not exist
          setstatusData([])
          setComplete(true)
          setloading(false);
        }
      });

    }else{
      setError(true);
    }
  
  
  
  }

  const variants = {
    in: { backgroundColor:"#f1f1ef", scale: [0.2, 0.8,1], borderRadius:['100%','100%','0%'], opacity:["0%","20%","100%"] },
    out: { backgroundColor: '#3cbb8d',scale:1,opacity:'100%',borderRadius:'0%' },
  }

  const renderIcon = (id,contrast) => {
    let icon; 
    switch (id) {
      case 0:
        icon = <Api height={40} width={40} background={contrast} />;
        break;
      case 4:
        icon = <Warehouse height={40} width={40} background={contrast} />;
        break;
      case 5:
        icon = <Assign height={40} width={40} background={contrast} />;
        break;
      case 6:
        icon = <Collect height={40} width={40} background={contrast} />;
        break;
      case 7:
        icon = <Delivery height={40} width={40} background={contrast} />;
        break;
      case 8:
        icon = <Delivered height={40} width={40} background={contrast} />;
        break;
      default:
        icon = <Api height={40} width={40} background={contrast} />;
        break;
    }

    return icon;
    
  }

  return (
    <motion.div
   // animate={{ , }}
    //transition={{ ease: "easeOut", duration: 0.5 }}
    animate={ "in"}
    variants={variants}
    transition={{
           // delay: 1,
           
            x: { type: "spring", stiffness: 100 },
            default: { duration: 0.5 },
          }}
    className="content-fluid p-0">
    <div className="row d-flex justify-content-center align-items-center d-flex-column" style={{minHeight: "100vh",margin:0}}>
     
          {isVisible && !Complete && (<>
            <AnimatePresence>
                  <motion.div animate={{
                    //borderRadius: ["100%", "0%"],
                    scale: [0.98,1,1],
                    y:[20,-10,0],
                    opacity:["0%","100%","100%"],
                  }}
                  initial={{ opacity:0 }}
                  // transition={{ ease: "easeIn", duration: 0.3 }}
                  transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                  className='col-md-3 align-self-center text-start p-3 shadow-sm bg-white' style={{borderRadius:15,position:'relative'}}>
                      {loading &&(<div style={{position:'absolute',right:30,top:10}}>
                        <motion.span
                          style={circleStyle}
                          animate={{ rotate: 360 }}
                          transition={spinTransition}
                        /></div>)}
                        <div className="mb-1 align-items-center text-center d-flex justify-content-center d-flex" style={{height:45}}>
                          <span className='d-inline align-center'><Logo width={20} height={27} /></span>
                          <p className="d-inline align-center text-center m-0 ms-2" style={{fontSize:24}}>Tracking</p>
                        </div>
                      <form onSubmit={handleSubmit}>
                        <motion.div
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-4">
                          <input type="text" className={error ? "form-control text-center is-invalid":"form-control text-center"} placeholder="N° de Tracking" value={formData.tracking} onChange={_handleTracking} />
                        {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>*/}
                        </motion.div>
                        
                      <button type="submit" disabled={loading} className="btn btn-primary text-white btn-block w-100" style={{position:'relative'}}>Seguir mi envio</button>
                      </form>
                      </motion.div></AnimatePresence></>
                  )}            
                {Complete && (
                    <AnimatePresence>
                      <div className='col-md-4 align-self-center'>
                      {statusData.map((st,index) => (
                       <motion.div key={index} animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.98,1,1],
                        y:[20,-10,0],
                        opacity:["0%","100%","100%"],
                        backgroundColor:st.color
                      }}
                      initial={{ opacity:0 }}
                    // transition={{ ease: "easeIn", duration: 0.3 }}
                      transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 },delay:0.1*index }}
                      className='col-md-12 align-self-center m-auto text-center p-3 shadow-sm mb-2' style={{borderRadius:15,position:'relative'}}>
                        <div className='row'>
                          <div className='col-md-2 align-self-center justify-content-end'>
                          {renderIcon(st.id,st.contrast)}
                          </div>
                          <div className='col-md-5 justify-content-start d-flex align-items-start'><p className="text-start my-auto p-0" style={{fontSize:20,color:st.contrast}}>{st.name}</p></div>
                          <div className='col-md-5 justify-content-end d-flex align-items-start text-end'><p className='text-white my-auto p-0 text-end' style={{fontSize:13}}>{moment(st.createAt).utcOffset(-3).format('DD-MM-YYYY HH:mm')}</p></div>
                        </div>
                      </motion.div>
                      ))}
                      </div>
                   </AnimatePresence>)}    
    </div>
  </motion.div>
  );
}

export default App;
